'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.previous = exports.next = exports.shuffle = exports.play = exports.select = exports.clear = exports.remove = exports.add = exports.setPlaylist = exports.setOption = undefined;

var _constants = require('../util/constants');

var setOption = exports.setOption = function setOption(id, key, value) {
  return {
    type: _constants.actionNames.SET_OPTION,
    id: id,
    key: key,
    value: value
  };
};

var setPlaylist = exports.setPlaylist = function setPlaylist(id, playlist) {
  return {
    type: _constants.actionNames.SET_PLAYLIST,
    id: id,
    playlist: playlist
  };
};

var add = exports.add = function add(id, media, playNow) {
  return {
    type: _constants.actionNames.ADD,
    id: id,
    media: media,
    playNow: playNow
  };
};

var remove = exports.remove = function remove(id, index) {
  return {
    type: _constants.actionNames.REMOVE,
    id: id,
    index: index
  };
};

var clear = exports.clear = function clear(id) {
  return {
    type: _constants.actionNames.CLEAR,
    id: id
  };
};

var select = exports.select = function select(id, index) {
  return {
    type: _constants.actionNames.SELECT,
    id: id,
    index: index
  };
};

var play = exports.play = function play(id, index) {
  return {
    type: _constants.actionNames.PLAY,
    id: id,
    index: index
  };
};

var shuffle = exports.shuffle = function shuffle(id, shuffled, playNow) {
  return {
    type: _constants.actionNames.SHUFFLE,
    id: id,
    shuffled: shuffled,
    playNow: playNow
  };
};

var next = exports.next = function next(id) {
  return {
    type: _constants.actionNames.NEXT,
    id: id
  };
};

var previous = exports.previous = function previous(id) {
  return {
    type: _constants.actionNames.PREVIOUS,
    id: id
  };
};